<template>
    <div class="salesmantuguangPage">  
        <mu-appbar class="XR-head" title="我要推广">
            <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
            <mu-icon-button v-on:click="openShareSheet()" icon=":fa fa-zhuanfa" slot="right" v-if="isApp"/>     
            <mu-icon-menu icon=":fa fa-detail" slot="right">
                <mu-menu-item to="/usercenter/index" title="个人中心"/>
                <mu-menu-item to="/" title="首页"/>
                <mu-menu-item to="/retail/cart" title="购物车"/>
            </mu-icon-menu>
        </mu-appbar> 
        <div class="head">
            <div class="step">
                <p>第①步 将店铺分享给您的好友</p>
                <p>第②步  好友注册成为店铺会员 </p>
                <p>第③步  好友消费，您拿奖金</p>
            </div>
            <span class="way-one">方 法 一</span>
            <span class="title">扫码推广</span>
            <div class="store">
                <p v-if="memberInfo.NickName">我是<span class="name">{{memberInfo.NickName}}</span></p>
                <p v-if="!memberInfo.NickName">我是<span class="name"><router-link to="/usercenter/person">点击设置昵称</router-link></span></p>
                <p>我为<span class="name">{{siteInfo.SiteName}}</span>代言</p>
                <p>你也来免费开分销店吧，别人消费你得奖金！</p>
            </div>
            <img class="erweima" :src ="memberInfo.Id>0?MOBILE_URL+'/wechatqrcode.aspx?uid='+memberInfo.Id:''" alt="" />
            <p class="scanning">扫一扫或长按此图，识别图中二维码</p>
        </div>
        <div class="bottom">
            <span class="way-two">方法二</span>
            <p class="title">微信内分享</p>
            <div class="rowOne">
                <p>点击分享名片，</p>
                <p>即可将您的店铺分享给微信好友，</p>
                <p>此方式只适用于微信中。</p>
            </div>
            <div class="rowTwo">
                <p>分销加盟，</p>
                <p>开创人人微商时代，</p>
                <p>零门槛创业，指尖分享，</p>
                <p>极致轻松赚钱，有钱就能任性，</p>
                <p>你也来试试吧！</p>
            </div>
            <div class="the_one">
                <p>第一步</p>
                <img src="/static/salesman/tuiguang/3.png" alt="" />
            </div>
            <div class="the_two">
                <p>第二步</p>
                <img src="/static/salesman/tuiguang/5.png" alt="" />
            </div>
        </div>
        
        <mu-bottom-sheet :open="shareSheet" @close="closeShareSheet">    
        <div class="salesmantuguangPage-shareSheetTitle">分享到</div>
        <div class="salesmantuguangPage-shareSheetWayList">
            <div class="shareSheetWayItem" @click="appWeChatFringtShareClick">
            <div class="shareWayIcon wechatFrind"><i class="fa fa-wechat"></i></div>
            <div class="shareWayText">微信好友</div>
            </div>
            <div class="shareSheetWayItem" @click="appWeChatFringtQuanShareClick">          
            <div class="shareWayIcon wechatFrindQuan"><i class="fa fa-diamonds"></i></div>
            <div class="shareWayText">朋友圈</div>
            </div>
        </div>   
        </mu-bottom-sheet>

    </div>
</template>

<script>
import siteconfig from '../../util/siteconfigCache'
import appShare from '../../util/appShare'
import wechatCache from '../../util/wechatCache'
export default {
    data () {
        return {
        memberInfo:{}   ,
        shopSetting:{}  ,        
        siteInfo: {},
        shareSheet:false,
        shareTitle:'',
        shareDesc:'',
        shareImgUrl:'',
        shareLinkUrl:'',  
        isApp:false
        }
    },
    created(){
        window.openShare = this.openShare
    },
    mounted(){          
        var url = window.location.href
        if(/[?]from=(.)*#/.test(url)){
            url = url.replace(/[?]from=(.)*#/g , "#")
            window.location.href = url
            return
        }

        var appClient = window.localStorage.appClient
            if(appClient == 'android' || appClient == 'ios'){
            this.isApp = true
        }
        this.getIndexInfo()
        this.getShopSetting()
        this.getSiteInfo()
    },  
    methods: {   
        getIndexInfo(){      
            const ths = this;
            this.$post("/Salesman/SalesmanServer/GetSalesmanIndexInfo")
            .then(function(res) {
            if (res.IsSuccess) {    
                if(res.Data.UserBs == 0){
                    ths.$router.push('/openSalesmanShop')
                    return;
                }
                ths.getMemberInfo()
            }
            })
            .catch(function(err) {
            console.log(err);
            });
        },  
        GoHistory(){
            this.$router.goBack()
        },
        getMemberInfo(){      
            var ths = this;   
            ths.$post(
            "/Shop/UserServer/GetUserInfo"
            ).then(function(res) {
            if(!res.IsSuccess){
                ths.$refs.XRtoast.failed(res.Msg, true)
            }else{    
                ths.loaded =false         

                ths.memberInfo=res.Data

                ths.initWeiXin()
            }
            });      
        },
        getShopSetting(){      
            var ths = this;   
            ths.$post(
            "/Salesman/SalesmanServer/GetShopSetting"
            ).then(function(res) {
            if(!res.IsSuccess){
                ths.$refs.XRtoast.failed(res.Msg, true)
            }else{    
                ths.loaded =false         

                ths.shopSetting=res.Data
            }
            });      
        },        
        getSiteInfo: function() {
            const ths = this;
            this.$post("/Shop/SiteConfigServer/GetSiteConfig")
            .then(function(res) {
                if (res.IsSuccess) {
                    ths.siteInfo = res.Data;
                    siteconfig.addSiteconfig(res.Data)
                }
            })
            .catch(function(err) {
                console.log(err);
            });
        },    
        initWeiXin(){ 
            var ths = this;   

            ths.shareTitle = ths.siteInfo.SiteName
            if(ths.shopSetting.ShopName){
                ths.shareTitle = ths.shopSetting.ShopName
            }
            ths.shareDesc = ths.siteInfo.WeChatShareText
            ths.shareImgUrl = ths.siteInfo.WeChatShareImage
            ths.shareLinkUrl = ths.siteInfo.WeChatShareUrl + '?recommendtype=1&uid='+ths.memberInfo.Id
            
            var openId = wechatCache.getOpenId()
            if(!openId){
                //this.$refs.XRtoast.failed('未获取微信信息', true)
                return
            }

            ths.$postBase(
            ths.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx?mid="+ths.memberInfo.Id
            ).then(function(res) {
            if(!res.IsSuccess){
                //ths.$refs.XRtoast.failed(res.Msg, true)
            }else{   
                if(res.Data.ShareDesc){
                    ths.shareDesc = res.Data.ShareDesc
                }                
                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: res.Data.AppId, // 必填，公众号的唯一标识
                    timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
                    nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
                    signature: res.Data.Sign, // 必填，签名，见附录1
                    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                });
                wx.ready(function () {
                    wx.onMenuShareTimeline({
                        title: ths.shareTitle, // 分享标题
                        link: ths.shareLinkUrl, // 分享链接
                        imgUrl: ths.shareImgUrl, // 分享图标
                        success: function () {
                        },
                        cancel: function () {
                            // 用户取消分享后执行的回调函数
                        }
                    });

                    wx.onMenuShareQQ({
                        title: ths.shareTitle, // 分享标题
                        desc: ths.shareDesc, // 分享描述
                        link: ths.shareLinkUrl, // 分享链接
                        imgUrl: ths.shareImgUrl, // 分享图标
                        success: function () {
                        },
                        cancel: function () {
                            // 用户取消分享后执行的回调函数
                        }
                    });

                    wx.onMenuShareAppMessage({
                        title: ths.shareTitle, // 分享标题
                        desc: ths.shareDesc, // 分享描述
                        link: ths.shareLinkUrl, // 分享链接
                        imgUrl: ths.shareImgUrl, // 分享图标
                        success: function () {
                        },
                        cancel: function () {
                            // 用户取消分享后执行的回调函数
                        }
                    });
                    wx.onMenuShareQZone({
                        title: ths.shareTitle, // 分享标题
                        desc: ths.shareDesc, // 分享描述
                        link: ths.shareLinkUrl, // 分享链接
                        imgUrl: ths.shareImgUrl, // 分享图标
                        success: function () {
                            // 用户确认分享后执行的回调函数
                        },
                        cancel: function () {
                            // 用户取消分享后执行的回调函数
                        }
                    });
                });
            }
            }); 
        },            
        closeShareSheet () {
            this.shareSheet = false
        },
        openShareSheet () {
            var appClient = window.localStorage.appClient
            if(appClient == 'ios'){      
                window.webkit.messageHandlers.ajax.postMessage({fun:'share',Ftitle: this.shareTitle,Fimage:this.shareImgUrl ,FjumpUrl: this.shareLinkUrl})
            }else{
                this.shareSheet = true
            }
        },            
        openShare(){
            this.shareSheet = true
        },
        appWeChatFringtShareClick(){
            appShare.shareWeChatFriend(this.shareTitle,this.shareDesc,this.shareImgUrl,this.shareLinkUrl)
        },    
        appWeChatFringtQuanShareClick(){
            appShare.shareWeChatFriendQuan(this.shareTitle,this.shareDesc,this.shareImgUrl,this.shareLinkUrl)
        }
    }
}
</script>
 <style>
    body .salesmantuguangPage{
        margin: 0;
        padding: 0;
    }
    .salesmantuguangPage .head{
        width: 100%;
        height: 680px;
        background: url(/static/salesman/tuiguang/1.png) no-repeat;
        background-size: 100% 100%;
        position: relative;
    }
    .salesmantuguangPage .head .step{
        width: 100%;
        position: absolute;
        top: 10%;
    }
    .salesmantuguangPage .head .step p{
        margin: 0;
        margin-bottom: 2px;
        color: #fff;
        font-size: 14px;
        transform: rotate(-5deg);
    }
    .salesmantuguangPage .head .step p:first-child{
        text-align: right;
        padding-right: 12%;
    }
    .salesmantuguangPage .head .step p:nth-child(2){
        text-align: center;
    }
    .salesmantuguangPage .head .step p:nth-child(3){
        padding-left: 12%;
    }
    .salesmantuguangPage .head span.way-one{
        color: #fff;
        position: absolute;
        top: 22%;
        left: 33%;
    }
    .salesmantuguangPage .head span.title{
        color: #0AFFF8;
        font-weight: bold;
        font-size: 24px;
        position: absolute;
        top: 28%;
        text-align: center;
        width: 100%;
    }
    .salesmantuguangPage .head .store{
        width: 100%;
        position: absolute;
        top: 38%;
        left: 10%;
    }
    .salesmantuguangPage .head .store p{
        margin: 0;
        font-size: 14px;
    }
    .salesmantuguangPage .head .store p span.name{
        color: #FE8531;
        padding: 0 5px;				
    }
    .salesmantuguangPage .head img.erweima{
        width: 30%;
        height: 18%;
        position: absolute;
        top: 70%;
        left: 35%;
    }
    .salesmantuguangPage .head .scanning{
        text-align: center;
        width: 60%;
        color: red;
        position: absolute;
        bottom: 5%;
        font-size: 14px;
        left: 20%;
    }
    .salesmantuguangPage .bottom{
        width: 100%;
        height: 1100px;
        background: url(/static/salesman/tuiguang/2.png) no-repeat;
        background-size: 100% 100%;
        position: relative;
    }
    .salesmantuguangPage .bottom .way-two{
        color: #fff;
        position: absolute;
        top: 1.2%;
        left: 33%;
    }
    .salesmantuguangPage .bottom p.title{
        margin: 0;
        width: 100%;
        color: #0AFFF8;
        font-weight: bold;
        font-size: 24px;
        position: absolute;
        top: 5%;
        text-align: center;
    }
    .salesmantuguangPage .bottom .rowOne{
        width: 100%;
        position: absolute;
        top: 12%;
    }
    .salesmantuguangPage .bottom .rowOne p{
        text-align: center;
        margin: 0;
        margin-bottom: 5px;
        font-size: 14px;
        color: #000;
    }
    .salesmantuguangPage .bottom .rowTwo{
        width: 100%;
        position: absolute;
        top: 20%;
    }
    .salesmantuguangPage .bottom .rowTwo p{
        text-align: center;
        margin: 0;
        margin-bottom: 5px;
        font-size: 14px;
    }
    .salesmantuguangPage .bottom .the_one{
        width: 80%;
        position: absolute;
        top: 31%;
        left: 10%;
    }
    .salesmantuguangPage .bottom .the_one p{
        color: #FF0000;
    }
    .salesmantuguangPage .bottom .the_one img{
        width: 100%;
    }
    .salesmantuguangPage .bottom .the_two{
        width: 80%;
        position: absolute;
        top: 55%;
        left: 10%;
    }
    .salesmantuguangPage .bottom .the_two p{
        color: #FF0000;
    }
    .salesmantuguangPage .bottom .the_two img{
        width: 100%;
    }
        
    .salesmantuguangPage-shareSheetTitle {
    line-height: 40px;
    font-size: 16px;
    padding: 20px 20px 0;
    }
    .salesmantuguangPage-shareSheetWayList {
    overflow: hidden;
    }
    .salesmantuguangPage-shareSheetWayList .shareSheetWayItem {
    float: left;
    padding: 20px;
    width: 100px;
    text-align: center;
    }
    .salesmantuguangPage-shareSheetWayList .shareSheetWayItem .shareWayIcon {
    font-size: 28px;
    border-radius: 50%;
    width:45px;
    height:45px;
    line-height: 45px;
    text-align: center;
    color:white;
    display: inline-block;
    }
    .salesmantuguangPage-shareSheetWayList .shareSheetWayItem .shareWayIcon.wechatFrind{
    background: #07BD13;
    }
    .salesmantuguangPage-shareSheetWayList .shareSheetWayItem .shareWayIcon.wechatFrindQuan{
    background: #99D021;
    }
    .salesmantuguangPage-shareSheetWayList .shareSheetWayItem .shareWayText {
    padding-top: 10px;
    }
      
</style>



// WEBPACK FOOTER //
// src/pages/salesman/tuiguang.vue